import { Drawer, Grid } from 'antd'
import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { AppHeader } from './Header'
import { PageHero } from './PageHero'
import { PixelatedWave } from '../motion/PixelatedWave'
import { ScrollReveal } from '../motion/ScrollReveal'
import { SmoothScrolling } from '../motion/SmoothScrolling'

const { useBreakpoint } = Grid

/**
 * The portal shell, after the website's web app: a floating glass rail on the
 * left (tablet and desktop), a glass top bar, and the wave video band behind
 * the top of every page. Below 768px the rail is replaced by a menu drawer.
 * Layout and styles live in shell.css. Lenis smooth scrolling, the
 * PixelatedWave page transition and the scroll reveals come from the website
 * (components/motion).
 */
export function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const screens = useBreakpoint()
  const location = useLocation()

  // `md` (768px) is where the website swaps its rail for phone navigation.
  const isPhone = !screens.md

  // Navigating on a phone should dismiss the drawer; otherwise it covers the
  // page the user just chose.
  useEffect(() => {
    setDrawerOpen(false)
  }, [location.pathname])

  return (
    <SmoothScrolling>
      <div className="fh-shell">
        <PageHero />
        <PixelatedWave />
        <ScrollReveal />
        <Sidebar variant="rail" />
        {isPhone && (
          <Drawer
            placement="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            width={280}
            styles={{ body: { padding: 0 } }}
            // The menu carries its own logo and navigation; a title would just
            // cost vertical space on the screens that have least of it.
            closable={false}
          >
            <Sidebar variant="panel" />
          </Drawer>
        )}
        <div className="fh-main">
          <header className="fh-topbar fh-glass">
            <AppHeader showMenuButton={isPhone} onMenuClick={() => setDrawerOpen(true)} />
          </header>
          <main className="fh-content">
            <Outlet />
          </main>
        </div>
      </div>
    </SmoothScrolling>
  )
}
